import Button from '@components/ui/ButtonV2/Button'
import { SwatchType } from '@components/ui/Swatch/Swatch'
import TextSwatch from '@components/ui/TextSwatch/TextSwatch'
import { UmbracoLink } from '@customTypes/umbracoLink'
import clsx from 'clsx'
import { ChangeEvent, FC, forwardRef, useEffect, useRef, useState } from 'react'
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/thumbs'
import s from './TextSwatchGroup.module.scss'

export interface TextSwatchGroupProps {
  groupName: string
  swatches: Omit<SwatchType, 'name'>[]
  className?: string
  configuratorLink?: UmbracoLink
}

const TextSwatchGroup: FC<TextSwatchGroupProps> = forwardRef(
  ({ swatches = [], groupName, className, configuratorLink }, ref) => {
    const [selected, setSelected] = useState<Omit<SwatchType, 'name'>>(
      swatches.find((x) => x.checked) ?? null,
    )
    const [fade, setFade] = useState(false)
    const rootRef = useRef<HTMLDivElement>(null)

    const handleSwatchChange = (e: ChangeEvent<HTMLInputElement>) => {
      const selectedSwatch = swatches.find(
        (swatch) => swatch.id === e.target.id,
      )
      if (selectedSwatch) {
        setSelected(selectedSwatch)
      }
    }

    useEffect(() => {
      setFade(true)
    }, [])

    useEffect(() => {
      setSelected(swatches.find((x) => x.checked) ?? null)
    }, [swatches])

    return (
      <div className={clsx(s.root, className)} ref={rootRef}>
        <div className={s.groupLabel}>
          <span className={s.labelName}>{groupName}:</span>
          <span className={s.labelValue}>{selected?.value}</span>
        </div>
        <ul className={s.grouplist}>
          {swatches.map((swatch, index) => (
            <li
              key={index + swatch.id + groupName}
              className={s['group-list-item']}
            >
              <TextSwatch
                id={swatch.id}
                name={groupName}
                value={swatch.value}
                label={swatch.label}
                checked={swatch.checked}
                disabled={swatch.disabled}
                onChange={handleSwatchChange}
              />
            </li>
          ))}

          {configuratorLink && (
            <>
              <li className={s.configuratorLink}>
                <Button
                  className={s['group-list-item']}
                  variant="secondary"
                  as="a"
                  href={configuratorLink.url}
                  target={configuratorLink.target || '_self'}
                >
                  {configuratorLink.name || 'Build your own'}
                </Button>
              </li>
            </>
          )}
        </ul>
      </div>
    )
  },
)
TextSwatchGroup.displayName = 'SwatchGroup'
export default TextSwatchGroup
